module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.classLevel === 'Bercario' || _vm.classLevel === 'Infantil') ? _c('div', {
    staticClass: "portlet box blue"
  }, [_c('div', {
    staticClass: "portlet-title"
  }, [_c('div', {
    staticClass: "caption"
  }, [_c('i', {
    staticClass: "fa fa-coffee",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Água e/ou suco")])])]), _vm._v(" "), _c('div', {
    staticClass: "portlet-body text-center p-b-0"
  }, [_c('div', {
    staticClass: "mt-radio-inline"
  }, _vm._l((_vm.quantityType), function(value, key) {
    return _c('label', {
      staticClass: "mt-radio mt-radio-outline"
    }, [_c('input', {
      attrs: {
        "type": "radio",
        "name": "water-quantity"
      },
      domProps: {
        "value": key,
        "checked": key === _vm.water
      },
      on: {
        "change": _vm.putAgendaWater
      }
    }), _vm._v("\n\t\t\t\t" + _vm._s(value) + "\n\t\t\t\t"), _c('span')])
  }))])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-49e0b61e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./sources/domains/agenda/alimentation/water/water.vue
// module id = 1067
// module chunks = 1